export const discountPercentHandler = (originalPrice, discountedPrice) => {
  if (originalPrice <= 0 || discountedPrice > originalPrice) {
    return
  }

  const discount = (originalPrice - discountedPrice) * 100
  return Math.round(discount / originalPrice)
}
